import { Directive, forwardRef, ElementRef, Renderer2, HostListener } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";

@Directive({
  selector: 'input[integersOnly]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IntegerOnlyDirective),
      multi: true
    }
  ],
  standalone: false
})
export class IntegerOnlyDirective implements ControlValueAccessor {

  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(
    private el: ElementRef<HTMLInputElement>,
    private renderer: Renderer2
  ) {}

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = [
      'Backspace', 'Delete', 'Tab',
      'ArrowLeft', 'ArrowRight', 'Home', 'End'
    ];

    if (allowedKeys.includes(event.key)) {
      return;
    }

    // Only numbers 0–9
    if (!/^\d$/.test(event.key)) {
      event.preventDefault();
    }
  }

  @HostListener('input')
  onInput() {
    const input = this.el.nativeElement;
    const sanitizedValue = input.value.replace(/[^0-9]/g, '');

    if (input.value !== sanitizedValue) {
      this.renderer.setProperty(input, 'value', sanitizedValue);
    }

    this.onChange(sanitizedValue);
  }

  writeValue(value: any): void {
    const normalized = value ?? '';
    if (this.el.nativeElement.value !== normalized) {
      this.renderer.setProperty(this.el.nativeElement, 'value', normalized);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();
  }
}